import React, { useState } from 'react';
import {
  Button
} from '@mui/material';
import { Approval as ApprovalIcon } from '@mui/icons-material';

import { AcceptAllReviewsDialog } from './acceptAllReviewsDialog.jsx';

function AcceptAllReviewsButton({
  isDisabled,
  handleAcceptAllReviews
}) {
  const [isDialogVisible, setIsDialogVisible] = useState(false);

  return (
    <>
      <Button
        disabled={isDisabled}
        variant="contained"
        disableElevation
        startIcon={<ApprovalIcon />}
        onClick={() => {
          setIsDialogVisible(true);
        }}
      >
        Accept All Reviews
      </Button>
      <AcceptAllReviewsDialog
        isOpen={isDialogVisible}
        handleAcceptAllReviews={handleAcceptAllReviews}
        handleClose={() => {
          setIsDialogVisible(false);
        }}
      />
    </>
  );
}

export { AcceptAllReviewsButton };
